import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MapService } from 'src/app/services/map.service';
import { OrdersService } from 'src/app/services/orders.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  standalone: false,
  selector: 'app-delivered-confirmation',
  templateUrl: './delivered-confirmation.component.html',
  styleUrls: ['./delivered-confirmation.component.scss'],
})
export class DeliveredConfirmationComponent {
  user;
  currentOrder;

  constructor(
    public modalController: ModalController,
    private authenticationService: AuthenticationService,
    private ordersService: OrdersService,
    private alertController: AlertController,
    private storageService: StorageService,
    private translateService: TranslateService,
    private mapService: MapService
  ) {
    this.user = this.authenticationService.userValue;
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async confirmOrderDelivered(order) {
    await this.mapService.markAsDelivered(order.id, true);
    await this.mapService.getOrders(false);
    const orderDelivered = this.translateService.instant('order-delivered');
    const orderDeliveredText = this.translateService.instant(
      'order-delivered-text'
    );
    const okay = this.translateService.instant('okay');
    const alert = await this.alertController.create({
      header: orderDelivered,
      message: orderDeliveredText,
      buttons: [okay],
    });

    await alert.present();
    this.closeModal();
  }
}
